import { ObjectMapper } from 'json-object-mapper';
import { IModel } from './IModel';

export class StateModel implements IModel<StateModel> {
  public code = 0;
  public name = '';
  public acronym = '';

  static create(input: any): StateModel {
    return ObjectMapper.deserialize<StateModel>(StateModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
